/*
 * @Description: 
 * @Author: -898-
 * @Date: 2025-03-05 10:36:38
 * @LastEditTime: 2025-03-11 15:42:41
 * @LastEditors: -898-
 */
import { login, getInfo, } from '@/api/supplierLogin'
import { getToken, setToken, setExpiresIn, removeToken, removeUsername } from '@/utils/auth'
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userName: "",
    userId: "",
    avatar: "",
    isCarInfo: false,
    router: [
      { title: "首页", path: "/index" },
      { title: "最新资讯", path: "/news" },
      { title: "电站地图", path: "/map" },
      { title: "企业服务", path: "/service" },
      { title: "APP下载", path: "/app" },
      { title: "用户社区", path: "/community" },
      // { title: "个人服务", path: "/person" },
      // { title: "企业服务", path: "/person" },
    ]
  },
  getters: {},
  mutations: {
    SET_NAME: (state, name) => {
      console.log(name, 'namenamenamename');
      state.userName = name;
      console.log(state, 'state.userNamestate.userName');
    },
    SET_ID: (state, id) => {
      state.userId = id;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar === null ? null : process.env.VUE_APP_PREVIEW_API + avatar;
    },
    SET_CarInfo: (state, val) => {
      state.isCarInfo = val
    },
  },
  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const account = userInfo.account.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      const userType = userInfo.userType
      const loginType = userInfo.loginType
      return new Promise((resolve, reject) => {
        // login(account, password, code, uuid, userType, loginType).then(res => {
        login(userInfo).then(res => {
          let data = res.data
          setToken(data.access_token)
          // commit('SET_TOKEN', data.access_token)
          setExpiresIn(data.expires_in)
          // commit('SET_EXPIRES_IN', data.expires_in)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    //修改用户信息
    getUserInfo ({ commit }) {
      getUserInfo().then((res) => {
        const { userName, userId, avatar } = res.data;
        commit("SET_NAME", userName);
        commit("SET_ID", userId);
        commit("SET_AVATAR", avatar);
      }).catch((err) => {
        //清除token
        removeToken()
      });
    },
    //获取用户信息
    getInfo ({ commit }) {
      getInfo().then((res) => {
        const { userName, userId, avatar } = res.data;
        commit("SET_NAME", userName);
        commit("SET_ID", userId);
        commit("SET_AVATAR", avatar);
      }).catch((err) => {
        //清除token
        removeToken()
      });
    },
    //退出登录
    logout ({ commit }) {
      commit("SET_NAME", "");
      commit("SET_ID", "");
      removeToken();
      removeUsername()
    }
  },
  modules: {},
});
